import { getRandomValue } from '@vas2t-lowcode/utils';
import { AxiosInstance } from 'axios';
import { PERFORMANCE_ENTRY_KEY } from '../constants';
import { AxiosRequestConfigExtends } from '../entities/axios-request-config-extends';

export function interceptRequest(service: AxiosInstance) {
  // 请求拦截器
  service.interceptors.request.use(
    async (config: AxiosRequestConfigExtends) => {
      // config.transformRequest = [
      //   function (data) {
      //     let ret = '';
      //     // eslint-disable-next-line guard-for-in
      //     for (const it in data) {
      //       ret +=
      //         encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
      //     }
      //     if (ret.endsWith('&')) {
      //       ret = ret.substr(0, ret.length - 1);
      //     } // 删除最后一个冗余的 &
      //     return ret;
      //   },
      // ];

      // 由账号插件生成 token 并添加到请求头
      try {
        // api的 URL Path，不包含参数，此处过滤 query 参数
        const pathArray = config.url?.split('?') || [];
        const popToken = await window.ksoAccount.signPopToken(
          config.method?.toUpperCase() || 'GET',
          pathArray[0] || ''
        );
        if (popToken !== 'empty' && config.headers) {
          config.headers['X-Pop-Token'] = popToken ?? '';
        }
      } catch (e) {
        console.warn('ksoAccount.signPopToken', e);
      }

      // #region 全局错误响应提示, 默认开启; 全局请求登录拦截，默认开启
      const customConfig = config.customConfig || (config.customConfig = {});
      const { showRespErrMsg, toLoginPage } = customConfig;
      if (showRespErrMsg === undefined || showRespErrMsg === null) {
        customConfig.showRespErrMsg = true;
      }
      if (toLoginPage === undefined || toLoginPage === null) {
        customConfig.toLoginPage = true;
      }
      // #endregion

      // #region 超时统计
      customConfig.timeData = { startTime: new Date() };
      // #endregion

      // #region 添加sentry上报网络详细信息的flag
      const ramVal = getRandomValue();
      if (config.params) {
        config.params[PERFORMANCE_ENTRY_KEY] = ramVal;
      } else {
        config.params = { [PERFORMANCE_ENTRY_KEY]: ramVal };
      }
      // #endregion
      return config;
    },
    (err) => {
      let msg = err?.message || '';
      if (typeof err === 'string') {
        msg = err;
      } else {
        // #region 超时统计
        err.config.timeData = err.config.timeData || {};
        err.config.timeData.endTime = new Date();
        // #endregion
      }

      console.warn('请求拦截器错误', msg);
      // const isTimeoutError = networkErrorHandler(err);

      // const isSlowResp = checkSlowResp(err?.config?.timeData || undefined);
      // setNetworkSlow(isSlowResp);
      return Promise.reject(err);
    }
  );
}
